import { BRAND } from "@/shared/constants.js";
import { inputBase } from "@/shared/utils/styles.js";

export const TextInput = ({ value, onChange, placeholder, type = "text", inputMode, maxLength, autoComplete, onBlur: onBlurProp, onKeyDown, style: extra, readOnly }) => (
  <input
    style={{ ...inputBase, ...(readOnly ? { opacity: 0.6, cursor: "default" } : {}), ...extra }}
    type={type} inputMode={inputMode} maxLength={maxLength} autoComplete={autoComplete}
    placeholder={placeholder} value={value} onChange={readOnly ? undefined : (e) => onChange(e.target.value)}
    readOnly={readOnly}
    onKeyDown={readOnly ? undefined : onKeyDown}
    onFocus={(e) => { if (!readOnly) e.target.style.borderColor = BRAND; }}
    onBlur={(e) => { e.target.style.borderColor = "#d0d0d0"; if (onBlurProp) onBlurProp(e); }}
  />
);
